/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {WinterHoard} from "../WinterHoard";
import {BuffaloSpinReelController} from "../reel/BuffaloSpinReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";
import {BuffaloTimelineReelsController} from "../reel/BuffaloTimelineReelsController";
import {SoundPlayer} from "../sound/SoundPlayer";

export class ReelStop implements GameRoundPresentation {
    private readonly _reelId:number;
    private _stopDelay:number;
    private _quickStopDelay:number;
    stagger?:number;
    abortStagger?:number;
    private _data:WinterHoardParsedGameData;
    private _nearWinReels:boolean [];
    private _isMysterySymbols:boolean = false;
    private _bigWinNearWinReels:boolean [];

    private _tl:Timeline;
    private _reelTl:Timeline;
    private _aborted:boolean = false;

    constructor(reelId:number, stagger?:number, abortStagger?:number) {
        this._reelId = reelId;
        this._stopDelay = WinterHoard.timelineReelsController.getReelConfig(this._reelId).stopDelay;
        this._quickStopDelay = WinterHoard.timelineReelsController.getReelConfig(this._reelId).quickStopDelay;

        //Override config
        if(stagger != undefined) {
            this._stopDelay = stagger;
        }
        if(abortStagger != undefined) {
            this._quickStopDelay = abortStagger;
        }

        this.stagger = this._stopDelay;
        this.abortStagger = this._quickStopDelay;

    }

    prepare(data:WinterHoardParsedGameData) {
            this._aborted = false;
            this._data = data;
            this._nearWinReels = this._data.nearWinReels;
            this._bigWinNearWinReels = this._data.nearWinBigWinReels;
            this._isMysterySymbols = this._data.shamanspinTriggered;
    }

    public getAnimation(data:SpinParsedGameData):Timeline {
        const nwStagger:number = 1.8;
        const tl:Timeline = new TimelineLite();
        this.stagger = GameSetting.isFastSpin ? this._quickStopDelay : this._stopDelay;

        if (this._nearWinReels[this._reelId] || (this._bigWinNearWinReels[this._reelId] && !this._isMysterySymbols)) {
            this.stagger += nwStagger;
        }
        else if(this._reelId + 1 <= 4 && (this._bigWinNearWinReels[this._reelId + 1] && !this._isMysterySymbols)){
            this.stagger += nwStagger;
        }
        // Special case:
        // if aborted and last bw near win is false nearWinBigWinReels: (5) [false, false, false, true, false]
        // TODO: quick spin case scatter near win.
        if(this._aborted && this._reelId === 4 && (!this._isMysterySymbols && data.nearWinBigWinReels[this._reelId - 1])){
            this.stagger += nwStagger;
        }

        let reelController:BuffaloSpinReelController = <BuffaloSpinReelController>Reels.getReel(this._reelId);
        reelController.updateGameData(this._data);

        const tlRl:Timeline = WinterHoard.timelineReelsController.stopSpin(this._reelId, this._data, this._aborted);

        if(GameSetting.isFastSpin && this._aborted) {
            this.stagger += this._reelId * 0.1;
        }


        tl.add(this._reelTl = tlRl, (this._aborted)? this.stagger : 0);
        //if(GameSetting.isFastSpin && this._aborted && (this._nearWinReels[this._reelId] || (this._bigWinNearWinReels[this._reelId] && !this._isMysterySymbols))) {
        //}
        this._tl = tl;
        return tl; // WinterHoard.timelineReelsController.stopSpin(this._reelId, data, false);
    }

    public abort(isActive:boolean, data:SpinParsedGameData):Timeline | null {
        //return WinterHoard.timelineReelsController.stopSpin(this._reelId, data, true);
        this._aborted = true;
        //this.stagger = this.abortStagger;
        (<BuffaloTimelineReelsController> WinterHoard.timelineReelsController).quickStopped = true;

        if (isActive){
            //this._reelTl.progress(1, false);
            //this._tl = WinterHoard.timelineReelsController.stopSpin(this._reelId, data, true);
            this._tl.add(() => {
                WinterHoardGameModuleConfig.nearWinView.resetOnReel(this._reelId);
            }, "-=0.3");

            if((this._reelId + 1 <= 4) && this._nearWinReels[this._reelId + 1] || (this._bigWinNearWinReels[this._reelId + 1] && !this._isMysterySymbols)) {
                this._tl.add(() => {
                    WinterHoardGameModuleConfig.nearWinView.playOnReel(this._reelId + 1, []);
                    SoundPlayer.playAnticipationSound(this._data!.mode);
                });
            }
            return this._tl;
        }
        //WinterHoard.timelineReelsController.stopSpin(this._reelId, data, true);
        this._tl = this.getAnimation(data);
        this._tl.add(() => {
            WinterHoardGameModuleConfig.nearWinView.resetOnReel(this._reelId);
        }, "-=0.3");

        if(this._reelId === 4) {
            //WinterHoardGameModuleConfig.nearWinView.forcedReset();
        }

        //this._reelTl.progress(1, false);
        return this._tl;
    }

}